import React, { useEffect, useState } from 'react';
import './YourAccountsPage.scss';
import { RadioButton } from 'primereact/radiobutton';
import { getUserAccounts } from '../../../shared/services/user/accounts/UserAccountsService';
import { UserAccountsResponse } from '../../../shared/models/user/accounts/UserAccountsResponse';
import Loader from '../../../shared/components/common/loader/Loader';
import { useAccount } from '../../../shared/contexts/account/AccountContexts';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { t } from 'i18next';
import { changeActiveAccount } from '../../../shared/services/user/UserService';
import { format } from 'date-fns';

const YourAccountsPage: React.FC = () => {
  const { accountResponse } = useAccount();
  const [userAccounts, setUserAccounts] = useState<UserAccountsResponse[] | null>(null);

  const permissionsMap = new Map([
    ['ADMIN', t('admin')],
    ['USER', t('user')],
    ['OWNER', t('owner')],
  ]);

  useEffect(() => {
    getUserAccounts().then((userAccounts) => setUserAccounts(userAccounts));
  }, []);

  const changeAccount = (id: number) => {
    changeActiveAccount(id).then(() => {
      window.location.reload();
    });
  };

  if (!userAccounts) {
    return <Loader />;
  }

  const actionTemplate = (userAccount: UserAccountsResponse) => {
    return (
      <RadioButton
        inputId="none"
        checked={userAccount.accountId === accountResponse?.accountId}
        name="options"
        value={userAccount.accountId}
        onChange={(ev) => changeAccount(ev.target.value)}
      />
    );
  };

  return (
    <div className="your-accounts-page">
      <div>
        <DataTable
          stripedRows
          paginator
          paginatorClassName="pagination"
          removableSort
          sortField="accountEmail"
          sortOrder={1}
          rows={50}
          rowsPerPageOptions={[10, 25, 50]}
          value={userAccounts}
          tableStyle={{ minWidth: '50rem' }}
          tableClassName="table"
          className="table-wrapper"
          currentPageReportTemplate={t('rowsNumber') + ':'}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        >
          <Column
            field="accountEmail"
            header={t('accountOwner')}
            headerClassName="table__header"
            body={(userAccount) => (
              <div>
                {userAccount.accountEmail}{' '}
                {userAccount.userRole === 'OWNER' && (
                  <span className="default-text">(Main account)</span>
                )}
              </div>
            )}
            style={{ minWidth: '120px' }}
          />
          <Column
            field="userRole"
            header={t('userRole')}
            headerClassName="table__header"
            body={(userAccount) => permissionsMap.get(userAccount.userRole)}
            style={{ width: '120px' }}
          />
          <Column
            field="created"
            header={t('created')}
            body={(userAccount) => format(userAccount.created, 'yyyy-MM-dd / HH:mm')}
            headerClassName="table__header"
            style={{ width: '280px' }}
          />
          <Column
            header={t('active')}
            headerClassName="table__header table__header--center"
            bodyClassName="table__cell table__cell--center "
            style={{ width: '40px' }}
            body={actionTemplate}
          />
        </DataTable>
      </div>
    </div>
  );
};

export default YourAccountsPage;
